import { SectionCard, SectionCardTitle } from "@/components";
import ContactImageGrid from "./ImageGrid";
import { ContactDetails } from "./ContactDetails";
import { Meta } from "@/components";
import { Helmet } from "react-helmet-async";

const OurProducts = () => {
  return (
    <>
    <Meta
      title="Intron - Contact Us"
    />
    <SectionCard className="px-4 lg:px-[90px] mx-0 h-auto">
      <div className="flex flex-col lg:flex-row items-start justify-between gap-10">
        <div className="lg:w-1/2 w-full lg:mt-25">
          <SectionCardTitle>Contact Us</SectionCardTitle>
          <p className="text-[14px] lg:text-[16px] leading-[24px] lg:leading-[28px] text-justify    text-[#415667] mt-4">
            Discover our diverse range of science-driven probiotic and biotech solutions for aquaculture, poultry, shrimp, fish, ruminants, and more.
          </p>
        </div>
        <div className="lg:w-2/3 w-full flex justify-start lg:justify-end">
        <div className="w-fit">
          <ContactImageGrid />
        </div>
        </div>

      </div>
    </SectionCard>
    <ContactDetails />
  </>
  );
};

export default OurProducts;
